import { render, staticRenderFns } from "./BaseEtymDetails.vue?vue&type=template&id=1bb786bc&scoped=true&"
import script from "./BaseEtymDetails.vue?vue&type=script&lang=js&"
export * from "./BaseEtymDetails.vue?vue&type=script&lang=js&"
import style0 from "./BaseEtymDetails.vue?vue&type=style&index=0&id=1bb786bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb786bc",
  null
  
)

export default component.exports